<template>
    <div class="chart-block">
        <!-- Legend -->
        <div class="legend-row">
            <span class="legend-item">
                <span class="legend-sq" style="background:#3b82f6;"></span>
                Contratos
            </span>
        </div>
        <Chart
            v-if="hasData"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            class="w-full"
        />
        <div v-else class="chart-empty">Sem dados</div>
    </div>
</template>

<script>
import SafeChart from '@/components/SafeChart.vue';

export default {
    name: 'ActiveBarMaioresClientes',
    components: { Chart: SafeChart },
    props: {
        rawData: { type: Object, default: () => ({}) },
        activeIndex: { type: Number, default: 0 }
    },
    computed: {
        hasData() {
            return this.rawData?.labels?.length && this.rawData?.datasets?.length;
        },
        chartData() {
            if (!this.hasData) return {};
            const count = (this.rawData.labels || []).length;
            const bgColors = Array.from({ length: count }, (_, i) =>
                i === this.activeIndex ? 'rgba(59,130,246,0.3)' : '#3b82f6'
            );
            const borderColors = Array.from({ length: count }, (_, i) =>
                i === this.activeIndex ? '#3b82f6' : 'transparent'
            );
            const datasets = this.rawData.datasets.map(ds => ({
                ...ds,
                backgroundColor: bgColors,
                borderColor: borderColors,
                borderWidth: 2,
                borderDash: [4, 4],
                borderRadius: 4,
                barPercentage: 0.55,
                categoryPercentage: 0.8,
            }));
            return { ...this.rawData, datasets };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(20,20,20,0.95)',
                        titleColor: '#e6edf3',
                        bodyColor: '#8b949e',
                        cornerRadius: 6,
                        padding: 8,
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: { color: '#8b949e', font: { size: 10 }, maxRotation: 30 }
                    },
                    y: {
                        grid: { color: 'rgba(255,255,255,0.06)', drawBorder: false },
                        ticks: { color: '#8b949e', font: { size: 11 } }
                    }
                }
            };
        }
    }
}
</script>

<style scoped>
.chart-block { height: 260px; display: flex; flex-direction: column; gap: 8px; }
.chart-block :deep(canvas) { flex: 1; min-height: 0; }
.chart-empty { flex: 1; display: flex; align-items: center; justify-content: center; color: #6b7280; }

.legend-row {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.legend-item {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 0.78rem;
    color: #c9d1d9;
}
.legend-sq {
    width: 22px;
    height: 8px;
    border-radius: 3px;
}
</style>
